module.exports = __webpack_public_path__ + "static/media/mapa.800483f3.png";